import { createFileRoute, Outlet, redirect, useChildMatches } from '@tanstack/react-router'
import { CashSaleListScreen } from '@/features/accounting-cash-sales/cash-sale-list-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/sales-receipts')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_cash_sale.view')) {
      throw redirect({ to: '/accounting', search })
    }
  },
  component: SalesReceiptsRoute,
})

function SalesReceiptsRoute() {
  return useChildMatches().length > 0 ? <Outlet /> : <CashSaleListScreen />
}
